let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cb7bI")).then(() => parcelRequire('f2iAx'));